import { Button, ButtonGroup } from '@material-ui/core';
import React, { useState } from 'react';
import { SelectionMenu, SelectionMenuProps } from './SelectionMenu';
import { ArrowDropDown, ArrowDropUp } from '@material-ui/icons';

export type ButtonWithSelectionMenuProps<T> = {
  buttonLabel: string;
  menuProps: Omit<SelectionMenuProps<T>, 'onClose' | 'isOpen' | 'anchorEl'>;
  onOpen?: () => Promise<void> | void;
  className?: string;
  disabled?: boolean;
};

export const ButtonWithSelectionMenu = <T,>(props: ButtonWithSelectionMenuProps<T>) => {
  const { buttonLabel, onOpen, className, disabled, menuProps } = props;
  const openMenu = async (event: { currentTarget: React.SetStateAction<HTMLElement | null> }): Promise<void> => {
    setRootAnchorEl(event.currentTarget);
    await onOpen?.();
  };
  const closeMenu = (): void => {
    setRootAnchorEl(null);
  };
  const [rootAnchorEl, setRootAnchorEl] = useState<null | HTMLElement>(null);

  const isOpen = !!rootAnchorEl;

  const handleSubmit = async (selectedItems: T[]) => {
    await menuProps.onSubmit(selectedItems);
    closeMenu();
  };

  return (
    <>
      <ButtonGroup
        onClick={openMenu}
        color="primary"
        disableElevation
        variant="outlined"
        aria-label="Disabled elevation buttons"
        className={className}
        disabled={disabled}
        data-testid={`${menuProps['data-testid']}-button-group`}
      >
        <Button data-testid={`${menuProps['data-testid']}-main-button`} disabled={disabled}>
          {buttonLabel}
        </Button>
        <Button style={{ width: '20px' }} disabled={disabled} data-testid={`${menuProps['data-testid']}-arrows-button`}>
          {!disabled && isOpen ? <ArrowDropUp /> : <ArrowDropDown />}
        </Button>
      </ButtonGroup>
      {!disabled && (
        <SelectionMenu
          {...menuProps}
          anchorEl={rootAnchorEl}
          onClose={closeMenu}
          isOpen={isOpen}
          onSubmit={handleSubmit}
        />
      )}
    </>
  );
};
